import React from "react";
import PropTypes from "prop-types";
import "../shared/Loading/skeleton.css";

/**
 * Shared loading veil for Analytics / scoped cards — and every other
 * dashboard widget that renders through it (Sales blocks included, see
 * LaborMetrics / ProfitTrend / DeptMetrics / GoalProgress).
 *
 * Cold load and date-filter refetches (This quarter, YTD, …) both use this
 * so a card never flashes real numbers, partial numbers, or a
 * finished-looking $0 while its data is still on the way.
 *
 * A graying skeleton, not a spinner (Kelvin's call, 2026-09-28): the shape of
 * the card holds, it just doesn't have its numbers yet — the same "hold the
 * shape" idea CustomWidget's own per-tile skeleton already used.
 */
const CardBusy = ({ active, label = "Loading…", cover = false }) => {
  if (!active) return null;
  return (
    <div
      className={`cs-busy${cover ? " cs-busy-cover" : ""}`}
      aria-busy="true"
      aria-live="polite"
      aria-label={label}
    >
      <span className="gmb-skel cs-busy-bar" style={{ width: "58%" }} />
      <span className="gmb-skel cs-busy-bar" style={{ width: "84%" }} />
      <span className="gmb-skel cs-busy-bar" style={{ width: "40%" }} />
    </div>
  );
};

CardBusy.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string,
  /* cover = solid white backdrop (cold start). Soft veil when false (refresh). */
  cover: PropTypes.bool,
};

CardBusy.defaultProps = {
  active: false,
  label: "Loading…",
  cover: false,
};

export default CardBusy;
